module.exports = __webpack_public_path__ + "img/bank-icon.d0d053f9.svg";